import getBookingDownloads from './getBookingDownloads';

const getBookingTicketDownloads = (state, bookingReference) =>
  getBookingDownloads(state, bookingReference).filter(
    ({ type }) => type === 'eticket',
  );

export default getBookingTicketDownloads;
